import type { HTMLAttributes } from "react";
import { StatusTag } from "@/views/components/StatusTag";

export interface Info {
    label: string;
    value?: string | number;
}

export interface DetailPageHeaderProps extends Omit<HTMLAttributes<HTMLDivElement>, "title"> {
    title: string;
    leftInfos?: Info[];
    rightInfos?: Info[];
    stateDesc?: string;
}

/** 详情页头部：保留 Vue 版本左右信息和状态文案的布局契约。 */
export default function DetailPageHeader({
    title,
    leftInfos = [],
    rightInfos = [],
    stateDesc,
    className,
    ...rest
}: DetailPageHeaderProps) {
    const value = (item: Info) => item.value ?? "--";
    return (
        <div className={`flex items-center justify-between ${className || ""}`} {...rest}>
            <div className="flex items-center text-xl font-medium text-black/88">
                <span>{title || "--"}</span>
                {leftInfos.map((item, index) => (
                    <span key={`${item.label}-${index}`} className="ml-4 text-sm font-normal text-[#8c8c8c]">
                        {item.label}
                        <span className="ml-2 text-[#333]">{value(item)}</span>
                    </span>
                ))}
            </div>
            <div className="flex items-center text-sm text-[#333]">
                {rightInfos.map((item, index) => (
                    <span key={`${item.label}-${index}`} className="mr-2 text-[#8c8c8c]">
                        {item.label}
                        <span className="ml-2 text-[#333]">{value(item)}</span>
                    </span>
                ))}
                {stateDesc ? <StatusTag className="ml-4">{stateDesc}</StatusTag> : null}
            </div>
        </div>
    );
}
